export default {
    SubmissionProgressBar: {
        details: 'Προσωπικά Στοιχεία',
        profPref: 'Επαγγελματικές προτιμήσεις',
        cvSend: 'Αποστολή Βιογραφικού'
    },
    SubmissionFormStep1: {
        name: 'Όνομα',
        surname: 'Επώνυμο',
        address: 'Διεύθυνση',
        city: 'Πόλη',
        state: 'Νομός',
        country: 'Χώρα',
        phone: 'Τηλέφωνο',
        invalidNumber: 'Ο αριθμός που πληκτρολογήσατε δεν είναι έγκυρος.',
        email: 'Email',
        gender: 'Φύλο',
        genderOptions: ['Άνδρας', 'Γυναίκα'],
        birthday: 'Ημερομηνία Γέννησης ',
        educationLevel: 'Επίπεδο Εκπαίδευσης',
        professionalExperience: 'Χρόνια προϋπηρεσίας'
    },
    SubmissionFormStep2: {
        department: 'Τμήμα',
        location: 'Τοποθεσία ',
        departmentOptions: ['Marketing', 'Πωλήσεις', 'Παραγωγή', 'Οικονομικές Υπηρεσίες', 'Λογιστήριο', 'R&D', 'Logistics', 'IT', 'Ανθρώπινο Δυναμικό', 'Άλλο'],
        departmentLocationOptions: ['Καλαμάτα', 'Αθήνα', 'Θεσσαλονίκη', 'Υπόλοιπη Ελλάδα', 'Ηνωμένο Βασίλειο', 'Βουλγαρία', 'Τουρκία', 'Άλλο'],
        selected: 'επιλεγμένα',
        priorPositionExperience: 'Χρόνια προϋπηρεσίας σε αντίστοιχη θέση',
        placeholder: 'Κανένα'
    },
    nextStep: {
        nextStep: 'επόμενο βήμα'
    },
    formHeader: {
        formHeaderStep1: 'Παρακαλώ συμπληρώστε τα παρακάτω πεδία προκειμένου να κάνετε αίτηση για θέση εργασίας. Τα πεδία με αστερίσκο (*) είναι υποχρεωτικά.',
        formHeaderStep2: 'Παρακαλώ επιλέξτε τα τμήματα και τις τοποθεσίες που σας ενδιαφέρουν. Τα πεδία με αστερίσκο (*) είναι υποχρεωτικά.',
        formHeaderStep3: 'Παρακαλώ συμπληρώστε τα παρακάτω πεδία προκειμένου να κάνετε αίτηση για θέση εργασίας. Τα πεδία με αστερίσκο (*) είναι υποχρεωτικά.'
    },
    SubmissionFormStep3: {
        coverLetter: 'Συνοδευτική Επιστολή',
        attachCV: 'Επισύναψη Βιογραφικού',
        submitApplication: 'υποβολή βιογραφικού',
        bigFileSizeError: 'To αρχείο που καταχωρήσατε είναι μεγαλύτερο του επιτρεπτού (2ΜΒ)',
        description: ['Τύπος Αρχείου: pdf', 'Μέγεθος Αρχείου: 2MB']
    },
    gdprInfo: {
        title: 'Ενημέρωση για επεξεργασία προσωπικών δεδομένων:',
        body: ['Θα εξετάσουμε το ενδεχόμενο απασχόλησής σας στην Εταιρεία μας, ανάλογα με τα προσόντα σας και τις εργασιακές μας ανάγκες. Θα διατηρήσουμε το βιογραφικό σας για μέγιστο χρονικό διάστημα δύο (2) ετών, προκειμένου να σας ενημερώσουμε, στην περίπτωση που παρουσιαστεί κάποια θέση κατάλληλη για εσάς. Κατά το χρονικό αυτό διάστημα, μπορείτε να μας ενημερώνετε για οποιαδήποτε συμπλήρωση του βιογραφικού σας, υποβάλλοντάς το, εκ νέου, μέσω της ιστοσελίδας μας (', 'www.karelia.gr', '). Πριν την αποστολή του βιογραφικού σας, σας συμβουλεύουμε να διαβάσετε την ', 'Πολιτική Απορρήτου', 'https://www.karelia.gr/politiki-aporritoy/', ', για την πληρέστερη ενημέρωσή σας. Για την διαγραφή του βιογραφικού σας καθώς και για οποιοδήποτε άλλο θέμα που σχετίζεται με δεδομένα προσωπικού χαρακτήρα παρακαλώ απευθυνθείτε στο ', 'dpo@karelia.gr']
    },
    errors: {
        emptyFieldError: 'Παρακαλούμε συμπληρώστε το πεδίο',
        wrongEmailFieldError: 'To email δεν είναι εγκυρο',
        invalidWorkExperience: 'Τα χρόνια εμπειρίας δεν είναι έγκυρα',
        emptyCvError: 'Παρακαλούμε επισυνάψτε βιογραφικό',
        somethingWentWrong: 'Παρακαλώ ελέγξτε ότι το αρχείο τηρεί τις παραπάνω παραμέτρους'
    },
    footer: {
        siteInfo: 'Ο διαδικτυακός τόπος που επισκέπτεστε έχει σκοπό την παροχή πληροφοριών σχετικά με την εταιρεία μας και την εμπειρία της στο χώρο των προϊόντων καπνού. Δεν προορίζεται για εμπορία, προώθηση ή διαφήμιση σημάτων τσιγάρων ή καπνικών προϊόντων.'
    },
    hero: {
        title: 'Γίνε μέλος της ομάδας μας'
    },
    successfulSubmission: 'Tο βιογραφικό σας υποβλήθηκε με επιτυχία. Ευχαριστούμε για το ενδιαφέρον.'
}